<script setup>
    import { ref, computed, watch, provide, onMounted, readonly } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    import { useSiteMenuStore } from '../../stores/sitemenu'
    import { useMatchingUpdateStore } from '../../pages/user/stores/matching/matchingUpdateStore'
    import _ from 'lodash'
    import { useAlertStore } from '../../stores/alertStore';

    const route = useRoute()
    const router = useRouter()
    const siteMenuStore = useSiteMenuStore();
    const userInStorage = sessionStorage.getItem('user')
    const matchingUpdateStore = useMatchingUpdateStore();

    const corpMasterYn = ref('');
    const propStateCnt = ref(0);
    const resStateCnt = ref(0);
    const userGb = ref('');
    if(userInStorage) {
      const { userInfo } = JSON.parse(userInStorage)
      corpMasterYn.value = userInfo.corpMasterYn;
      userGb.value = userInfo.userGb;
    }
    if(matchingUpdateStore) {
      propStateCnt.value = matchingUpdateStore.matchingUpdate.propStateCnt;
      resStateCnt.value = matchingUpdateStore.matchingUpdate.resStateCnt;
    }

    const masterMenuId = [96]; // 상시채용관 현황(96)

    const { $alert } = useAlertStore();

    // 기업마스터인지 아닌지 확인하여 메뉴 리스트 만들기
    const myPageMenu = computed( ()=> {
        const originalMenu =  _.find(siteMenuStore.menuList, { menuAreaGb: '02', menuId: 29});
        // originalMenu가 없거나 child 프로퍼티가 없거나 배열이 아닌 경우
        if(!originalMenu || !originalMenu.child || !Array.isArray(originalMenu.child)) {
          //console.log('Menu data is invalid.');
          return [];
        }

        const filterMenu = [];
        for(let i=0; i < originalMenu.child.length; i++) {
          if(masterMenuId.indexOf(originalMenu.child[i].menuId) > -1) {
            if(corpMasterYn.value === 'Y'){
              filterMenu.push(originalMenu.child[i]);
            }
          } else {
            filterMenu.push(originalMenu.child[i]);
          }
        }
        filterMenu.menuName = originalMenu.menuName;
        return filterMenu;
    })

    // menuList가 준비된 후 동작하도록
    const hasMenuList = computed(() => siteMenuStore.menuList && siteMenuStore.menuList.length > 0)

    // 메뉴가 없을 때 API 호출
    onMounted(() => {
        if (siteMenuStore.menuList.length === 0) {
            siteMenuStore.getSiteMenu();
        }
    })

    const onClickMenu = (menu) => {
        const closeMenuId = [33, 34];
        if(closeMenuId.indexOf(menu.menuId) > -1) {
            $alert("준비중 입니다.");
        } else{
            router.push(menu.menuUrl);
        }
    }

    const isCurrentRoute = (menuUrl) => {
        const currentPath = route.path;
        // 이력서/채용공고 페이지에서 mode가 openRecruitment이면 기업공채관 현황 메뉴 활성화
        const isOpenRecruitmentMode = route.query?.mode === 'openRecruitment' || route.query?.mode === 'mypageOpenRecruitment';
        if (isOpenRecruitmentMode &&
            (currentPath === '/mypage/jobFair/userJobFairResumeCreate' ||
             currentPath === '/mypage/jobFair/userJobFairResume' ||
             currentPath === '/mypage/jobFair/entry' ||
             currentPath === '/mypage/corpJobFair/jobNoticeCreat' ||
             currentPath === '/mypage/corpJobFair/jobNotice' ||
             currentPath === '/mypage/corpJobFair/recruitmentHall')) {
            // 메뉴 URL 중 '기업공채관 현황' 메뉴만 활성화
            const openRecruitmentMenu = myPageMenu.value.find(menu =>
                menu.menuName === '기업공채관 현황'
            );
            return openRecruitmentMenu && openRecruitmentMenu.menuUrl === menuUrl;
        }
        // 기업공채관 현황 상세 페이지일 때도 활성화
        if (currentPath.startsWith('/mypage/openRecruitment/') ||
            currentPath.startsWith('/mypage/corpOpenRecruitment/')) {
            const openRecruitmentMenu = myPageMenu.value.find(menu =>
                menu.menuName === '기업공채관 현황'
            );
            return openRecruitmentMenu && openRecruitmentMenu.menuUrl === menuUrl;
        }
        return currentPath === menuUrl || currentPath.startsWith(`${menuUrl}/`);
    }

    const hideSnb = computed(() => {
        // Never hide SNB menu
        return false;
    });
</script>

<template>
    <div v-if="!hideSnb && hasMenuList">
        <div class="title page-title">
            <h3>{{ myPageMenu.menuName }}</h3>
        </div>
        <ul>
            <li :class="{'on': isCurrentRoute(childMenu.menuUrl)}" v-for="childMenu in myPageMenu" :key="childMenu.menuId">
                <span v-if="corpMasterYn === 'Y'">
                  <span v-if="propStateCnt > 0 && childMenu.menuId === 61" class="red-dot"></span>
                  <span v-else-if="resStateCnt > 0 && childMenu.menuId === 62" class="red-dot"></span>
                </span>
                <span v-else-if="userGb === 'STUDENT'">
                  <span v-if="resStateCnt > 0 && childMenu.menuId === 65" class="red-dot"></span>
                  <span v-else-if="propStateCnt > 0 && childMenu.menuId === 66" class="red-dot"></span>
                </span>
                <a href="javascript:void(0);" @click="onClickMenu(childMenu)">{{ childMenu.menuName }}</a>
            </li>
        </ul>
    </div>
</template>

<style lang="scss" scoped>
    @import "../../assets/scss/theme";

    .snb {
        float: left;
        width: 272px;
        ul {
            border: $border_line;
            padding: 24px;
            li {
                display: flex;
                align-items: center;
                @include font-size_md;
                border-bottom: $border_line;
                padding: 16px 0;
                &:first-child {
                    padding-top: 0;
                }
                &:last-child {
                    border-bottom: 0;
                    padding-bottom: 0;
                }
                &.on {
                    color: $blue_color;
                    font-weight: 700;
                }
                i {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 18px;
                    height: 18px;
                    font-style: normal;
                    @include font-size_xs;
                    background: $red_color;
                    color: #fff;
                    border-radius: 50%;
                    text-align: center;
                    margin-left: 4px;
                }
            }
        }
    }
</style>
